export function formatNumber(num: number | undefined): string {
  if (num === undefined || num === null) return "0";
  if (num === 0) return "0";
  return num.toFixed(3).replace(".", ",");
}
